import React, { Component } from "react"
import axios from "axios"
import { Button, FormControl, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import snackBar from "../../../../../../../../../utilities/snackBar/SnackBar"
import AxiosConfig from "../../../../../../../../../utilities/AxiosConfig"
import IncidentAppointmentTypes from "../../../../../../../Types/IncidentAppointmentTypes"
import incidentAppointmentParams from "../IncidentAppointmentParams"
import DatePicker from "../../../../../../../../../components/common/DatePicker"
import moment from "moment"
import "./EditIncidentAppointment.css"

interface Props {
    toggleEditAppointment: Function
    editAppointment: Function
    removeAppointment: Function
    IncidentId: number
    timeFormat: string
    userId: string | number
    appointment: IncidentAppointmentTypes
    readOnly: boolean
}

interface State {
    appointment: IncidentAppointmentTypes | {}
    copy: IncidentAppointmentTypes | {}
    saving: boolean
    eventType: string
    isDirty: boolean
    confirmDiscard: boolean
    confirmDelete: boolean
}

class EditIncidentAppointment extends Component<Props, State> {

    timeFormat = "YYYY-MM-DD"

    state = {
        appointment: incidentAppointmentParams,
        copy: incidentAppointmentParams,
        saving: false,
        eventType: "",
        isDirty: false,
        confirmDiscard: false,
        confirmDelete: false
    }
    setEventType = (s: string) => {
        this.setState({ eventType: s })
    }

    componentDidMount() {
        this.setState({ appointment: JSON.parse(JSON.stringify(this.props.appointment)), copy: JSON.parse(JSON.stringify(this.props.appointment)) })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let appointment = this.state.appointment
        let eventType = this.state.eventType
        let eventTypes = Object.keys(appointment)
        let temp: any = appointment
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    appendParams = (params: Array<object>) => {
        const self = this
        let temp = this.state.appointment
        for (let i = 0; i < params.length; i++) {
            let key = Object.keys(params[i])
            let value = Object.values(params[i])
            if (value[0] !== "") {
                temp[key[0]] = value[0]
            } else {
                temp[key[0]] = null
            }
        }
        this.setState({ appointment: temp })
        setTimeout(() => {
            self.submitCheck()
        }, 200)
    }

    submitCheck = () => {
        if (JSON.stringify(this.state.appointment) !== JSON.stringify(this.state.copy)) {
            this.setState({ isDirty: true })
        } else {
            this.setState({ isDirty: false })
        }
    }

    save = (rb: IncidentAppointmentTypes) => {
        this.setState({ saving: true })
        rb.ModifiedBy = this.props.userId
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentMedicalAppointmentPost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                snackBar({ text: "Appointments updated", type: "success", timeout: 4000 })
                this.props.editAppointment(rb)
                this.props.toggleEditAppointment()
            })
            .catch(err => {
                //console.log(err)
                this.setState({ saving: false })
                snackBar({ text: "Failed to add or update appointment(s)", type: "error", timeout: 4000 })
                this.props.toggleEditAppointment()
            })
    }

    delete = (rb: IncidentAppointmentTypes) => {
        this.setState({ saving: true, confirmDelete: false })
        rb.DeletedBy = this.props.userId
        rb.DeletedDateUtc = moment(Date.now()).format(this.timeFormat)
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentMedicalAppointmentPost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                snackBar({ text: "Appointment removed", type: "success", timeout: 4000 })
                this.props.removeAppointment(rb)
                this.props.toggleEditAppointment()
            })
            .catch(err => {
                //console.log(err)
                this.setState({ saving: false })
                snackBar({ text: "Failed to remove appointment", type: "error", timeout: 4000 })
                this.props.toggleEditAppointment()
            })
    }

    back = () => {
        if (!this.state.isDirty) {
            this.props.toggleEditAppointment()
        } else {
            this.setState({ confirmDiscard: true })
        }
    }

    confirmDiscard = (discard: boolean) => {
        if (discard) {
            this.props.toggleEditAppointment()
        } else {
            this.setState({ confirmDiscard: false })
        }
    }

    confirmDelete = (confirmDelete: boolean) => {
        if (confirmDelete) {
            this.setState({ confirmDelete: true })
        } else {
            this.setState({ confirmDelete: false })
        }
    }

    render() {

        const readOnly = this.props.readOnly

        // //console.log("Appointment Props: ", this.props)
        // //console.log("Appointment State: ", this.state)
        // //console.log("Appointment Params: ", appointmentParams)
        // //console.log("Dirty?: " + this.state.isDirty)

        const DeleteAppointemntToolTip = (
            <Tooltip id="uac-tool-tip">
                Remove Appointment
            </Tooltip>
        )

        return (
            <div className="EditIncidentAppointment">
                {!this.state.confirmDiscard && !this.state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditIncidentAppointmentHeader">
                            <p>Edit appointment details</p>
                            {!readOnly && <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={DeleteAppointemntToolTip}>
                                <span id="incident-delete-appointment-icon" className="material-icons" onClick={() => this.confirmDelete(true)}>delete</span>
                            </OverlayTrigger>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="EditIncidentAppointmentBody">
                            <div className="IncidentAppointmentDatePickerWrapper">
                                <p>Date</p>
                                <DatePicker
                                    value={this.state.appointment.AppointmentDateUTC || ""}
                                    onChange={(val: number) => this.appendParams([{ AppointmentDateUTC: moment(val.valueOf()).format(this.props.timeFormat) }])}
                                    type="input"
                                    useCloseCallback
                                    disabled={readOnly}
                                />
                            </div>
                            <FormControl onFocus={() => this.setEventType("AppointmentDesc")}
                                as="textarea"
                                rows={4}
                                placeholder={"Description"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.appointment.AppointmentDesc || ""}
                                disabled={readOnly}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EditIncidentAppointmentFooter">
                            {readOnly && <Button id="edit-incident-appointment-save-back-btn" variant="secondary" onClick={() => this.back()}>Back</Button>}
                            {!this.state.saving && !readOnly && <Button id="edit-incident-appointment-save-back-btn" variant="secondary" onClick={() => this.back()}>Cancel</Button>}
                            {this.state.isDirty && !readOnly && !this.state.saving && <Button id="edit-incident-appointment-save-btn" variant="primary" onClick={() => this.save(this.state.appointment)} >Save</Button>}
                            {this.state.saving && <Spinner id="edit-incident-appointment-saving-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditIncidentAppointmentDiscardModalHeader">
                            <p>Are you sure you want to quit? Any unsaved changes will be lost.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="EditIncidentAppointmentDiscardModalFooter">
                            <Button variant="secondary" onClick={() => this.confirmDiscard(false)} >Back</Button>
                            <Button variant="danger" onClick={() => this.confirmDiscard(true)}>Quit</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditIncidentAppointmentDiscardModalHeader">
                            <p>Delete this appointment?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="EditIncidentAppointmentDiscardModalFooter">
                            <Button variant="secondary" onClick={() => this.confirmDelete(false)} >Back</Button>
                            <Button variant="danger" onClick={() => this.delete(this.state.appointment)}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }

}

export default EditIncidentAppointment